declare global {
    interface Window { TIME_MAKER_BASE_URL: string }
}


export default class ConfigProvider {
    static TimeMakerBaseUrl = window.TIME_MAKER_BASE_URL ?? ""
}